import { Component, Input, OnInit, EventEmitter } from '@angular/core';
import { NzNotificationService } from 'ng-zorro-antd/notification';
import { MiscellaneousService } from 'src/app/apps/authentication/miscellaneous.service';
import { AuthenticationService } from 'src/app/authentication.service';
import { AdmCompany } from 'src/app/models/adm-company';
import { AppInitService } from 'src/app/services/app-init.service';
import { LayoutService } from '../layout.service';
import * as g from 'src/app/globals';

@Component({
  selector: 'app-application-company-switcher',
  templateUrl: './application-company-switcher.component.html',
  styleUrls: ['./application-company-switcher.component.less'],
})
export class ApplicationCompanySwitcherComponent implements OnInit {
  @Input() userIdentity: any;
  companies: AdmCompany[];
  switching = false;

  afterLogin = new EventEmitter();
  constructor(
    private miscellaneousService: MiscellaneousService,
    private notificationService: NzNotificationService,
    private appInitService: AppInitService,
    private layoutService: LayoutService,
    private authenticationService: AuthenticationService,
  ) {}

  ngOnInit(): void {
    if (this.userIdentity.Area === 1) {
      this.getCompanies();
    }

    this.afterLogin.subscribe(() => {
      this.authenticationService.getIdentityDetails().subscribe((d) => {
        this.userIdentity = d;
        this.switching = false;
      });
    });
  }

  getCompanies() {
    const userName = this.userIdentity.UserCode;
    this.miscellaneousService
      .getCompanies(userName)
      .subscribe((companies: AdmCompany[]) => {
        this.companies = companies;
      });
  }

  changeCompany(company: AdmCompany) {
    this.switching = true;
    this.authenticationService
      .logout(company.companyDB)
      .subscribe((tokenResult: any) => {
        if (tokenResult.Has_Error) {
          this.switching = false;
          this.notificationService.error(
            this.layoutService.translate('Switch company failed'),
            tokenResult.Error_Message,
          );
        } else {
          if (!g.tokenInCookie) {
            localStorage.setItem('token', tokenResult.Resault_Value);
          } else {
            document.cookie = `token=${tokenResult.Resault_Value}; path=/; max-age=3600; Secure; SameSite=Strict`;
          }
          this.authenticationService.afterLogin(
            tokenResult.Resault_Value,
            true,
            document,
            this.afterLogin,
            this.appInitService,
          );
        }
      });
  }
}
